import { ArrowUpRight, ShieldCheck } from 'lucide-react';
import type { Project } from '../content/projects';

const proofLabels: Record<Project['proofStyle'], string> = {
  'operating-layer': 'Operating proof',
  governance: 'Governance proof',
  traceability: 'Traceability proof',
  'data-insight': 'Data insight',
  outcome: 'Outcome proof',
  'future-signal': 'Future signal'
};

export function ProjectCard({ project, index }: { project: Project; index: number }) {
  return (
    <article id={project.id} className="project-card">
      <img src={project.image} alt={project.imageAlt} />
      <div className="project-card-body">
        <div className="project-card-topline"><span>{String(index + 1).padStart(2, '0')}</span><span>{project.kicker}</span></div>
        <h3><a href={`/projects/${project.id}`}>{project.title}</a></h3>
        <p>{project.summary}</p>
        <div className="project-proof"><ShieldCheck size={15} aria-hidden="true" /> {proofLabels[project.proofStyle]}</div>
        <ul>{project.highlights.map((item) => <li key={item}>{item}</li>)}</ul>
        <a className="project-card-arrow" href={`/projects/${project.id}`} aria-label={`Open ${project.title} details`}><ArrowUpRight size={18} aria-hidden="true" /></a>
      </div>
    </article>
  );
}
